export const base64toBlob = (base64: string) => {
  // Split into two parts
  const parts = base64.split(";base64,");

  // Hold the content type
  const imageType = parts[0].split(":")[1];

  // Decode Base64 string
  const decodedData = window.atob(parts[1]);

  // Create UNIT8ARRAY of size same as row data length
  const uInt8Array = new Uint8Array(decodedData.length);

  // Insert all character code into uInt8Array
  for (let i = 0; i < decodedData.length; ++i) {
    uInt8Array[i] = decodedData.charCodeAt(i);
  }

  // Return BLOB image after conversion
  return new Blob([uInt8Array], { type: imageType });
};

/**
 * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
 * images to fit into a certain area.
 * source: https://stackoverflow.com/a/14731922
 * @param {Number} srcWidth width of source image
 * @param {Number} srcHeight height of source image
 * @param {Number} maxWidth maximum available width
 * @param {Number} maxHeight maximum available height
 * @return {Object} { width, height }
 */
export const calculateAspectRatioFit = (
  srcWidth: number,
  srcHeight: number,
  maxWidth: number,
  maxHeight: number
) => {
  let ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);

  return { width: srcWidth * ratio, height: srcHeight * ratio };
};

export const getImgDimensions = async (base64: string) => {
  const img = new Image();
  img.src = base64;
  await img.decode();
  return { width: img.width, height: img.height };
};

/**
 * calculate size in bytes
 * source: https://lioncoding.com/calculate-a-file-size-from-base64-string/
 */
export const getImgSize = (base64: string): number => {
  const start = `data:image/png;base64,`;
  const base64ImageData = base64.slice(start.length);
  const base64Length = base64ImageData.length;

  let fileSizeInByte = Math.ceil(base64Length / 4) * 3;

  if (base64Length >= 2) {
    let paddings = base64ImageData.slice(-2);
    if (paddings === "==") fileSizeInByte -= 2;
    else if (paddings[1] === "=") fileSizeInByte -= 1;
  }
  return fileSizeInByte;
};

let i = 1;
export const uuid = () => {
  i += 1;
  return `comp-${Date.now()}-${i}`;
};

/// source: https://stackoverflow.com/questions/5306680/move-an-array-element-from-one-array-position-to-another
export const arrayMove = (arr: any[], fromIndex: number, toIndex: number) => {
  const newArr = [...arr];
  newArr.splice(toIndex, 0, newArr.splice(fromIndex, 1)[0]);
  return newArr;
};

/// source: https://stackoverflow.com/a/57272491/5935917
export const toBase64 = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
